export const UPDATE_SUCCESS_MESSAGE = '更新が完了しました。';
export const USER_CREATE_SUCCESS_MESSAGE = 'ユーザー登録が完了しました。';
export const USER_DELETE_SUCCESS_MESSAGE = 'ユーザー削除が完了しました。';
export const USER_EDIT_SUCCESS_MESSAGE = 'ユーザー情報変更が完了しました。';
export const COGNITO_USER_NAME_EXISTS_ERROR_MESSAGE = '既に登録されているEメールアドレスです。';
export const SEND_SUCCESS_MESSAGE = '送信が完了しました。';
export const DEFAULT_ERROR_MESSAGE = 'エラーが発生しました';
export const COGNITO_ERROR_MESSAGE = 'エラーが発生しました。システム管理者に連絡してください。';
export const INTERNAL_SERVER_ERROR_MESSAGE = 'サーバーエラーが発生しました';
export const NO_RESULT_ERROR_MESSAGE =
  '検索条件に合致するデータがありませんでした';
export const NO_EXPORT_DATA_ERROR_MESSAGE =
  '出力対象となるデータがありませんでした';
export const PDF_EXPORT_ERROR_MESSAGE =
  `エラーが発生しました。以下の理由が考えられます。
  ・出力されるファイルサイズが大きい可能性があるため、件数を減らして出力してください。
  ・出力対象となるデータがありませんでした。出力対象の受付が存在するか確認してください。`;
export const CSV_EXPORT_ERROR_MESSAGE =
  `エラーが発生しました。以下の理由が考えられます。
  ・出力対象となるデータがありませんでした。出力対象の受付が存在するか確認してください。`;

interface StringKeyObject {
  [key: string]: any;
}
// TODO 使ってないの消す

export const INPUTTER_VALUES: StringKeyObject = {
  '1': '契約者本人',
  '2': '契約者の配偶者',
  '3': '契約者の同居の親族',
  '4': '契約者の別居の2親等内の親族',
};

export const INSURANCE_REQUEST_VALUES: StringKeyObject = {
  '1': '希望する',
  '2': '希望しない',
};

export const INSURANCE_TYPE_VALUES: StringKeyObject = {
  '1': '一般条件',
  '2': '車対車限定危険特約',
};
export const RESPONSE_STATUS_VALUES: StringKeyObject = {
  '1': '未対応',
  '4': 'LINE（承諾まち）',
  '6': 'LINE（承諾済み）',
  '7': 'LINE（確認あり）',
  '5': 'LINE（承諾督促中）',
  '10': 'LINE（回答まち）',
  '11': 'LINE（回答あり）',
  '12': 'LINE（不備督促中）',
  '3': 'OUT要',
  '2': '対応中',
  '8': '反映待ち',
  '13': 'フロント連携',
  '9': '完了',
};
export const CAR_TAB_RESPONSE_STATUSES = [
  '1',
  '4',
  '6',
  '7',
  '5',
  '10',
  '11',
  '12',
  '3',
  '2',
  '8',
  '13',
  '9',
];
export const FIRE_AND_INJURY_TAB_RESPONSE_STATUSES = [
  '1',
  '10',
  '11',
  '12',
  '3',
  '2',
  '8',
  '13',
  '9',
];
export const CHANGE_TYPE_VALUES: StringKeyObject = {
  '1': '住所',
  '2': '証券',
  '3': '車両入替',
  '4': '年齢・限定',
  '5': '使用目的',
  '6': '口座（書面）',
  '7': 'クレカ',
  '8': '解約',
  '9': '単独解約',
  '10': '中断解約',
  '11': '口座（ネット）',
};
export const CAR_TAB_CHANGE_TYPES = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '11',
  '7',
  '9',
  '10',
];
export const FIRE_AND_INJURY_TAB_CHANGE_TYPES = ['1', '2', '6', '11', '7', '8'];
export const CONTRACT_TYPE_VALUES: StringKeyObject = {
  '1': 'ご契約者さまご本人',
  '2': 'ご契約者さまご本人以外',
};
export const EXSTENCE_TYPE_VALUES: StringKeyObject = {
  '0': '無し',
  '1': '有り',
};
export const PERSONAL_TYPE_VALUES: StringKeyObject = {
  '1': '個人',
  '2': '法人',
};
export const INSURANCE_TYPE_MAPS: StringKeyObject = {
  'car': 1,
  'fire': 2,
  'injury': 3,
};
export const INSURANCE_LINE_VALUES: StringKeyObject = {
  '1': '自動車',
  '2': '火災',
  '3': '傷害・その他',
};
export const ADDRESS_CHANGE_INSURANCE_LINE_VALUES: StringKeyObject = {
  '1': '自動車',
  '2': '火災',
  '3': 'その他',
};
export const SYOKEN_INSURANCE_LINE_VALUES: StringKeyObject = {
  '1': '自動車',
  '2': '火災',
};
export const PAYMENT_INSURANCE_LINE_VALUES: StringKeyObject = {
  '1': '自動車',
  '2': '火災',
  '3': 'その他',
};
export const PAYMENT_VALUES: StringKeyObject = {
  '1': '口座振替',
  '2': 'クレジットカード払い',
};

export const PREFERRED_PROCEDURE_VALUES: StringKeyObject = {
  '1': 'ネット口座振替受付サービス',
  '2': '書面',
};

export const SYOKEN_REISSIE_REASON: StringKeyObject = {
  '1': '紛失',
  '2': '破損・汚損',
  '3': '証券未着',
  '4': 'その他',
};
export const YESNO_TYPE_VALUES: StringKeyObject = {
  '1': 'はい',
  '0': 'いいえ',
};
export const REQUIRED_TYPE_VALUES: StringKeyObject = {
  '1': '要',
  '2': '不要',
};
export const ESTATE_TYPE_VALUES: StringKeyObject = {
  '1': '賃貸',
  '2': '所有',
};
export const CANCELLATION_REASON_VALUES: StringKeyObject = {
  '1': '他社切替',
  '2': '当社で新契約加入に伴う解約（当社他代理店への変更のための解約含む）',
  '3': '廃車',
  '4': '譲渡（売却）・リース返還',
  '5': '車検切れ',
  '6': '海外渡航',
  '7': '他の契約へのお車の入れ替えに伴う解約',
  '8': '盗難',
  '9': 'ナンバー返納(一時的な登録抹消)',
  '10': '転居',
  '11': '売却',
  '12': '取り壊し',
  '13': '補償不要',
  '14': '被保険者死亡',
  '15': 'その他',
};
export const NEW_INSURANCE_LINE_VALUES: StringKeyObject = {
  '1': 'THEクルマの保険',
  '2': 'SGP',
};
export const DESTINATION_VALUES: StringKeyObject = {
  '1': 'お手続き書類と「変更手続き完了のお知らせ」の両方を現在のご住所に送付',
  '2': 'お手続き書類と「変更手続き完了のお知らせ」の両方を新住所に送付',
  '3': 'お手続き書類は現在のご住所、「変更手続き完了のお知らせ」は新住所に送付',
};
export const ADDRESS_CHANGE_UPDATE_CONTENTS_VALUES: StringKeyObject = {
  '1': '住所変更のみ',
  '2': '電話番号変更のみ',
  '3': '住所変更・電話番号変更',
};
export const SAME_OR_NOT_TYPE_VALUES: StringKeyObject = {
  '1': '同じ',
  '2': '異なる',
};
export const AFTER_CURRENT_PURPOSE: StringKeyObject = {
  '1': '業務に利用',
  '2': '通勤・通学に利用',
  '3': '日常・レジャーに利用',
};
export const APPLICABLE_CHECK: StringKeyObject = {
  '1': '該当する',
  '2': '該当しない',
};
export const DRIVER_TYPE_VALUES: StringKeyObject = {
  '1': '記名被保険者本人',
  '2': '記名被保険者の配偶者',
  '3': '記名被保険者本人または配偶者の同居のご親族',
  '4': '記名被保険者本人または配偶者の別居の未婚の子',
  '5': '記名被保険者本人、配偶者または同居のご親族の営む業務に従事する使用人',
  '6': '記名被保険者本人または配偶者の別居の親族、知人等',
};
export const PERIOD_UNIT: StringKeyObject = {
  '1': '年',
  '2': '月',
};
export const CAR_INSURANCE_TYPE: StringKeyObject = {
  '1': '一般条件',
  '2': '車対車限定危険特約',
};
export const HOW_TO_GET_CAR: StringKeyObject = {
  '1': 'ローン購入',
  '2': '一括購入',
  '3': 'リース',
  '4': '上記いずれにも該当しない',
  '99': '不明'
};
export const IS_LEASE_TERM_MORE_THAN_1_YEAR: StringKeyObject = {
  '1': '1年以上',
  '2': '1年未満',
};
export const IS_CAR_FOR_WELFARE: StringKeyObject = {
  '1': '該当する',
  '2': '該当しない',
  '99': '不明'
};
export const INDIVIDUAL_OR_CORPORATE: StringKeyObject = {
  '1': '個人（1901以降）',
  '2': '個人（1812以前）',
  '3': '法人',
};
export const DETAIL_CANCEL_REASON: StringKeyObject = {
  '1': '他の保険契約と保険の開始日と終了日を統一するための解約',
  '2': '他の保険契約と保険の開始日と終了日を統一するための解約ではない',
};
export const PLUS_MINUS: StringKeyObject = {
  '1': '+',
  '2': '-',
};
export const DRIVER_LICENSE_COLOR: StringKeyObject = {
  '1': 'ブルー',
  '2': 'ゴールド',
  '3': 'グリーン',
};
export const GENDER: StringKeyObject = {
  '1': '男性',
  '2': '女性',
};
export const PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE: StringKeyObject = {
  '1': '口座・団体（分割）',
  '2': '口座・団体（一括追徴）',
  '3': '口座（一括返還）',
  '4': 'クレカ（分割）',
  '5': 'クレカ（一括追徴）',
  '6': 'クレカ（一括返還）',
  '7': '非金銭',
};

export const PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE_TEXT: StringKeyObject = {
  '0': '',
  '1': '〇月から変更後の保険料を請求いたします。',
  '2': '〇月に一括で請求いたします。',
  '3': 'お返しする保険料はご登録の口座へお振込みいたします。',
  '4':
    '〇月15日から変更後の保険料を請求いたします。お客さまへの請求額変更のタイミングは、クレジットカード会社の明細をご確認ください。',
  '5':
    '〇月15日にクレジットカード会社へ請求いたします。お客さまへ請求されるタイミングは、クレジットカード会社の明細をご確認ください。',
  '6':
    '〇月15日にクレジットカード会社へ返金いたします。お客さまへ返金されるタイミングは、クレジットカード会社の明細をご確認ください。',
  '7': '保険料に変更はございません。',
};

export const LINE_MESSAGE_TYPE: StringKeyObject = {
  '1': '承諾依頼（初回）',
  '2': '承諾依頼（誤入力）',
  '3': '承諾依頼（督促）',
}

export const CHAT_TYPE: StringKeyObject = {
  '1': '承諾依頼',
  '2': '-',
  '4': '申込内容確認（Yes/No）',
  '5': '申込内容確認（テキストのみ）',
  '6': '申込内容確認（画像のみ）',
  '7': '申込内容確認（テキスト＆画像）'
}

export const CALL_PREFERRED_TIME: StringKeyObject = {
  '1': '連絡希望(午前)',
  '2': '連絡希望(午後)'
}

export const LINE_MESSAGE_TEMPLATE: StringKeyObject = {
  '0': '',
  '1':
    'WEB受付フォームで受付した変更お手続きの保険料計算が完了いたしました。以下のURLへアクセスいただき、変更内容がご意向どおりか確認の上、「承諾」ボタンを押して下さい。',
  '2':
    '大変申し訳ございません。先ほどお送りいたしました変更お手続きの内容に一部誤りがありました。正しい内容を再度お送りいたしますので以下のURLへアクセスの上、変更内容がご意向どおりか確認の上、「承諾」ボタンを押して下さい。',
  '3':
    '先日WEB受付フォームで受付した変更お手続きの保険料計算が完了し、LINEにて変更内容のご確認のお願いをお送りいたしましたが、現時点でご連絡を頂戴していないため、再度メッセージをお送りいたしました。以下のURLへアクセスいただき、変更内容がご意向どおりか確認の上、「承諾」ボタンを押して下さい。なお、ご連絡のない場合は取扱代理店・営業店に取次いたしますのでご了承ください。',
};

export const DELETE_FLAG_TYPE: StringKeyObject = {
  '0': '-',
  '1': '削除する',
};

export const CHECK_EXISTENCE: StringKeyObject = {
  '1': 'あり',
  '2': 'なし',
};

export const CHANGE_EXISTENCE: StringKeyObject = {
  '1': '変更する',
  '2': '変更しない',
};

export const DRIVER_AGE_CONDITION: StringKeyObject = {
  '1': '35歳以上',
  '2': '26歳以上',
  '3': '21歳以上',
  '4': '全年齢',
};

export const DRIVER_LIMITED_CONDITION: StringKeyObject = {
  '1': '本人限定',
  '2': '本人・配偶者限定',
  '3': '家族限定',
  '4': '運転者限定なし',
};

export const NEW_INSURANCE_SECTION: StringKeyObject = {
  '1': '団体扱・集団扱',
  '2': '一般契約',
};

export const API_NAME = 'FormsAdminApi'

export const OPERATION_TYPE: StringKeyObject = {
  '1': '受付新規申込',
  '2': '受付詳細更新',
  '3': 'LINEチャット　承諾依頼メッセージ送信',
  '4': 'LINEチャット　フリーメッセージ送信',
  '5': 'ステータス一括更新',
  '6': 'コール日一括入力',
  '7': 'ロック取得',
  '8': 'ロック解除',
  '9': '承諾結果回答',
  '10': 'システムリリース',
  '11': '申込内容確認（Yes/No）',
  '12': '申込内容確認（テキストのみ）',
  '13': '申込内容確認（画像のみ）',
  '14': '申込内容確認（テキスト＆画像）',
  '15': '回答-申込内容確認（Yes/No）',
  '16': '回答-申込内容確認（テキストのみ）',
  '17': '回答-申込内容確認（画像のみ）',
  '18': '回答-申込内容確認（テキスト＆画像）',
  '19': '本人確認結果更新（NG->OK）',
  '20': '本人確認結果更新（OK->NG）',
  '21': '本人確認結果更新（未突合->OK）',
  '22': '本人確認結果更新（未突合->NG）',
}

export const NECESSARY_CHANGE_TYPES_MAP: StringKeyObject = {
  'car': {
    'replacementOfVehicles': ['3'],
    'age': ['4'],
    'purpose': ['5'],
    'netAccount': ['11']
  },
  'fireAndInjury': {
    'netAccount': ['11']
  }
}

export const ALLOWED_CHANGE_TYPES_MAP: StringKeyObject = {
  'car': {
    'replacementOfVehicles': ['1', '2', '4', '5', '6', '11', '7', '9', '10'],
    'age': ['1', '2', '5', '6', '11', '7', '9', '10'],
    'purpose': ['1', '2', '6', '11', '7', '9', '10'],
    'netAccount': ['1', '2']
  },
  'fireAndInjury': {
    'netAccount': ['1', '2']
  }
}

export const NON_FINANCIAL_MESSAGE_TYPE: StringKeyObject = {
  '4': '確認（初回）',
  '5': '確認（誤送信）',
  '6': '確認（督促）',
  '7': 'フリー',
}

export const NON_FINANCIAL_FORM_TYPE: StringKeyObject = {
  '2': 'フリーメッセージ',
  '4': '申込内容確認（Yes/No）',
  '5': '申込内容確認（テキストのみ）',
  '6': '申込内容確認（画像のみ）',
  '7': '申込内容確認（テキスト＆画像）',
}

export const ALLOWERD_FORM_TYPES_MAP_BY_MESSAGE_TYPE: StringKeyObject = {
  '4': ['4', '5', '6', '7'],
  '5': ['4', '5', '6', '7'],
  '6': ['4', '5', '6', '7'],
  '7': ['2'],
  'all': ['2', '4', '5', '6', '7'],
}

export const NON_FINANCIAL_LINE_MESSAGE_TEMPLATE: StringKeyObject = {
  '0': '',
  '4': 'WEB受付フォームで受付したお手続きについて、ご確認いただきたい内容があります。\n以下のURLへアクセスいただき、フォームに従ってご回答ください。',
  '5': '大変申し訳ございません。先ほどお送りいたしましたWEB受付フォームの確認内容に一部誤りがありました。正しい内容を再度お送りいたしますので以下のURLへアクセスの上、フォームに従ってご回答ください。',
  '6': 'WEB受付フォームで受付したお手続きに関し、ご確認いただきたい内容があり、先日ご確認のお願いをお送りいたしましたが、現時点でご連絡を頂戴していないため、再度メッセージをお送りいたしました。以下のURLへアクセスいただき、フォームに従ってご回答ください。なお、ご連絡のない場合は取扱代理店・営業店に取次いたしますのでご了承ください。',
  '7': '',
};

export type IdentifiedStateLabels = 'OK' | 'NG' | '-'
export type IdentifiedStateValues = 1 | 2 | 3

export type IdentifiedState = {
  LABEL: IdentifiedStateLabels,
  VALUE: IdentifiedStateValues
}

export const IDENTIFIED_STATE = {
  OK: {
    LABEL: 'OK',
    VALUE: 1,
  } as IdentifiedState,
  NG: {
    LABEL: 'NG',
    VALUE: 2,
  } as IdentifiedState,
  UNIDENTIFIED: {
    LABEL: '-',
    VALUE: 3
  } as IdentifiedState,
} as const

export const IS_SMS_SENDING_REQUIRED: StringKeyObject = {
  '要': 1,
  '否': 2,
};


export type StringLabel = {
  label: string;
};


export type FeeCategoryValue = {
  value: 0 | 1 | 2;
};

type FeeCategory = StringLabel & FeeCategoryValue;

/**
 * フィー区分
 */
 export const FEE_CATEGORY: ReadonlyArray<FeeCategory> = [
  {label: 'ノンフィー', value: 0},
  {label: 'フィー', value: 1},
  // NOTE:SF上の定義では「販売特化」だが、画面表示を「フィー」で統一したいという要望があったためコメントアウトしている
  // {label: 'フィー', value: 2},
];

export type CancellationValue = {
  value: 0 | 1;
};

type CancellationCategory = StringLabel & CancellationValue;

/**
 * 解約区分
 */
export const CANCELLATION_CATEGORY: ReadonlyArray<CancellationCategory> = [
  {label: '受付型', value: 0},
  {label: '完結型', value: 1},
];

export type LineChatAvailabilityValue = {
  value: 1 | 2;
};

type LineChatAvailability = StringLabel & LineChatAvailabilityValue;

/**
 * LINE区分(可否)
 */
 export const LINE_CHAT_AVAILABILITY: ReadonlyArray<LineChatAvailability> = [
  {label: '可', value: 1},
  {label: '不可', value: 2},
];